import React, { useState, useRef, useEffect } from "react";

import { HelpIconButtonWrapperWithTooltip } from "@components/molecules/help-icon-button-wrapper-with-tooltip/help-icon-button-wrapper-with-tooltip";

import styles from "./help-icon-with-popover.module.scss";
import { useClickOutsideListener } from "@src/hooks/use-click-outside-listener";
import { GradientBorderContainer } from "@components/templates/layouts/gradient-border-container/gradient-border-container";
import { Help } from "@src/cloud-connect/help/entities/help";
import { HelpRepository } from "@src/cloud-connect/help/repositories/help-repository";
import { FaqButton } from "./faq-button";
import { ContactButton } from "./contact-button";
import { useI18N } from "@src/language/language-context";

const cssClassName = "help-icon-with-popover";

export const HelpIconWithPopover = () => {
  const popoverRef = useRef();
  const i18n = useI18N();
  const [isHelpPopoverOpen, setIsHelpPopoverOpen] = useState(false);
  const [isHelpIconActive, setIsHelpIconActive] = useState(false);
  const [help, setHelp] = useState(undefined);

  const handleClick = () => {
    const toggle = (prev) => !prev;
    setIsHelpPopoverOpen(toggle);
    setIsHelpIconActive(toggle);
  };

  useClickOutsideListener(popoverRef, handleClick, isHelpPopoverOpen);

  useEffect(() => {
    setHelp(new Help(new HelpRepository()));
  }, []);

  return (
    <span className={styles[cssClassName]}>
      <HelpIconButtonWrapperWithTooltip
        isHelpIconActive={isHelpIconActive}
        handleClick={handleClick}
      />
      {isHelpPopoverOpen && (
        <div className={styles[`${cssClassName}__popover-wrapper`]}>
          <GradientBorderContainer>
            <span
              ref={popoverRef}
              className={styles[`${cssClassName}__popover`]}
            >
              <span className={styles[`${cssClassName}__text`]}>
                {i18n("modules.helpButton.needHelp")}{" "}
                <span className={styles[`${cssClassName}__text--gray`]}>
                  {i18n("modules.helpButton.weGotYou")}
                </span>
              </span>
              <span
                className={
                  styles[`${cssClassName}__popover-button-link-wrapper`]
                }
              >
                <FaqButton url={help.getFaqUrl()} />
                <ContactButton url={help.getContactUrl()} />
              </span>
            </span>
          </GradientBorderContainer>
        </div>
      )}
    </span>
  );
};
